export default __webpack_public_path__ + "static/O0295-c94638c5943d6d81352c019290e8f63a.png";